const translations = {
  selectAssets: 'Asset selection',
  'errors.loadAll': 'Error loading all assets',
  'errors.loadAllMessage': 'There was a problem loading the complete list of assets.',
  'errors.load': 'Error loading assets',
  'errors.loadMessage': 'There was a problem loading the list of assets.'
}

export default translations
